function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var chatMenuTemplate = require('./chat-user-menu.template');
var ContactsList = require('./../../../../lib/saito/ui/modals/saito-contacts/saito-contacts');
var MemberList = require('./member-list.template');
var ChatUserMenu = /*#__PURE__*/function () {
  function ChatUserMenu(app, mod, chat_group) {
    _classCallCheck(this, ChatUserMenu);
    this.app = app;
    this.mod = mod;
    this.chat_group = chat_group;
    this.overlay = new SaitoOverlay(app, null, true, true);
  }
  return _createClass(ChatUserMenu, [{
    key: "render",
    value: function render() {
      var _this = this;
      var thisobj = this;
      if (!this.chat_group) {
        return;
      }
      if (!document.querySelector('#saito-chat-menu')) {
        this.overlay.show(chatMenuTemplate(this.app, this.mod, this.chat_group), function () {
          _this.app.connection.emit('chat-manager-render-request');
          _this.app.connection.emit('chat-popup-refresh-request', _this.chat_group);
        });
        this.attachEvents();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this$chat_group,
        _this2 = this;
      var thisobj = this;
      var suggestedName = this.chat_group.name;
      if (this.chat_group.members.length == 2 && !((_this$chat_group = this.chat_group) !== null && _this$chat_group !== void 0 && _this$chat_group.member_ids)) {
        var _iterator = _createForOfIteratorHelper(this.chat_group.members),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var m = _step.value;
            if (m !== this.mod.publicKey) {
              suggestedName = m;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (document.getElementById('rename')) {
        document.getElementById('rename').onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            var name, _thisobj$chat_group;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return sprompt('What do you want to call the chat group?', suggestedName);
                case 1:
                  name = _context.v;
                  if (name) {
                    thisobj.chat_group.name = sanitize(name);
                    if ((_thisobj$chat_group = thisobj.chat_group) !== null && _thisobj$chat_group !== void 0 && _thisobj$chat_group.member_ids && thisobj.chat_group.member_ids[thisobj.mod.publicKey] == 'admin') {
                      console.log('Send new name as group tx');
                      thisobj.mod.sendUpdateGroupTransaction(thisobj.chat_group);
                    }
                    thisobj.mod.saveChatGroup(thisobj.chat_group);
                    _this2.app.connection.emit('chat-manager-render-request');
                  }
                  thisobj.overlay.remove();
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('mute')) {
        document.getElementById('mute').onclick = function (e) {
          _this2.chat_group.muted = true;
          _this2.mod.saveChatGroup(_this2.chat_group);
          _this2.app.connection.emit('chat-manager-render-request');
          _this2.overlay.remove();
        };
      }
      if (document.getElementById('unmute')) {
        document.getElementById('unmute').onclick = function (e) {
          _this2.chat_group.muted = false;
          _this2.mod.saveChatGroup(_this2.chat_group);
          _this2.app.connection.emit('chat-manager-render-request');
          _this2.overlay.remove();
        };
      }
      if (document.getElementById('block')) {
        document.getElementById('block').onclick = function (e) {
          var _iterator2 = _createForOfIteratorHelper(_this2.chat_group.members),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var pkey = _step2.value;
              if (pkey !== _this2.mod.publicKey) {
                if (!_this2.mod.black_list.includes(pkey)) {
                  _this2.mod.black_list.push(pkey);
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          _this2.mod.deleteChatGroup(_this2.chat_group);
          _this2.overlay.remove();
          _this2.app.connection.emit('chat-popup-remove-request', _this2.chat_group);
        };
      }
      if (document.getElementById('unblock')) {
        document.getElementById('unblock').onclick = function (e) {
          for (var i = _this2.mod.black_list.length; i >= 0; i--) {
            if (_this2.mod.black_list[i] == e.currentTarget.dataset.id) {
              _this2.mod.black_list.splice(i, 1);
              break;
            }
          }
          _this2.mod.saveOptions();
          _this2.overlay.remove();
        };
      }
      if (document.getElementById('invite')) {
        document.getElementById('invite').onclick = function (e) {
          _this2.mod.generateChatGroupLink(_this2.chat_group);
        };
      }
      if (document.getElementById('delete')) {
        document.getElementById('delete').onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  thisobj.mod.deleteChatGroup(thisobj.chat_group);
                  thisobj.overlay.remove();
                  _this2.app.connection.emit('chat-popup-remove-request', _this2.chat_group);
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('admin')) {
        document.getElementById('admin').onclick = function (e) {
          var contactList = new ContactsList(_this2.app, _this2.mod, false);
          contactList.title = 'Promote to Admin';
          contactList.callback = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(person) {
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    if (person) {
                      if (!thisobj.chat_group.members.includes(person)) {
                        thisobj.chat_group.members.push(person);
                      }
                      thisobj.chat_group.member_ids[person] = 'admin';
                      thisobj.mod.sendUpdateGroupTransaction(thisobj.chat_group);
                      _this2.mod.saveChatGroup(thisobj.chat_group);
                      thisobj.overlay.remove();
                      thisobj.render();
                    }
                  case 1:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }();
          contactList.render(thisobj.chat_group.members.filter(function (x) {
            return thisobj.chat_group.member_ids[x] == 1;
          }));
        };
      }
      if (document.getElementById('leave')) {
        document.getElementById('leave').onclick = /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  _context4.n = 1;
                  return _this2.mod.sendRemoveMemberTransaction(thisobj.chat_group, _this2.mod.publicKey);
                case 1:
                  _this2.mod.deleteChatGroup(thisobj.chat_group);
                  siteMessage('You left the chat group', 2000);
                  _this2.overlay.remove();
                  _this2.app.connection.emit('chat-popup-remove-request', _this2.chat_group);
                case 2:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x4) {
            return _ref4.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('remove')) {
        document.getElementById('remove').onclick = /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(e) {
            var contactList;
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  contactList = new ContactsList(_this2.app, _this2.mod, false);
                  contactList.title = 'Remove Member';
                  contactList.callback = /*#__PURE__*/function () {
                    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(person) {
                      var i;
                      return _regenerator().w(function (_context5) {
                        while (1) switch (_context5.n) {
                          case 0:
                            _context5.n = 1;
                            return _this2.mod.sendRemoveMemberTransaction(thisobj.chat_group, person);
                          case 1:
                            i = 0;
                          case 2:
                            if (!(i < thisobj.chat_group.members.length)) {
                              _context5.n = 4;
                              break;
                            }
                            if (!(thisobj.chat_group.members[i] == person)) {
                              _context5.n = 3;
                              break;
                            }
                            thisobj.chat_group.members.splice(i, 1);
                            return _context5.a(3, 4);
                          case 3:
                            i++;
                            _context5.n = 2;
                            break;
                          case 4:
                            thisobj.chat_group.member_ids[person] = -1;
                          case 5:
                            return _context5.a(2);
                        }
                      }, _callee5);
                    }));
                    return function (_x6) {
                      return _ref6.apply(this, arguments);
                    };
                  }();
                  contactList.render(thisobj.chat_group.members.filter(function (x) {
                    return thisobj.chat_group.member_ids[x] == 1;
                  }));
                  console.log(thisobj.chat_group.members, thisobj.chat_group.member_ids);
                case 1:
                  return _context6.a(2);
              }
            }, _callee6);
          }));
          return function (_x5) {
            return _ref5.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('view')) {
        document.getElementById('view').onclick = /*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
            var overlay;
            return _regenerator().w(function (_context8) {
              while (1) switch (_context8.n) {
                case 0:
                  overlay = new SaitoOverlay(_this2.app, _this2.mod); // >>>>>>> Use a component here!
                  overlay.show("<div class=\"chat-member-list-overlay saito-modal\"><div class=\"saito-modal-title\">".concat(_this2.app.browser.escapeHTML(thisobj.chat_group.name), "</div>").concat(MemberList(_this2.app, _this2.mod, thisobj.chat_group), "</div>"));
                  console.log(JSON.parse(JSON.stringify(thisobj.chat_group.members)), JSON.parse(JSON.stringify(thisobj.chat_group.member_ids)));

                  // Add .remove_user functionality
                  Array.from(document.querySelectorAll('.remove_user')).forEach(function (member) {
                    member.onclick = /*#__PURE__*/function () {
                      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(e) {
                        var person, i;
                        return _regenerator().w(function (_context7) {
                          while (1) switch (_context7.n) {
                            case 0:
                              person = e.currentTarget.dataset.id;
                              if (!person) {
                                _context7.n = 5;
                                break;
                              }
                              _context7.n = 1;
                              return thisobj.mod.sendRemoveMemberTransaction(chat, person);
                            case 1:
                              i = 0;
                            case 2:
                              if (!(i < chat.members.length)) {
                                _context7.n = 4;
                                break;
                              }
                              if (!(chat.members[i] == person)) {
                                _context7.n = 3;
                                break;
                              }
                              chat.members.splice(i, 1);
                              return _context7.a(3, 4);
                            case 3:
                              i++;
                              _context7.n = 2;
                              break;
                            case 4:
                              chat.member_ids[person] = -1;
                            case 5:
                              return _context7.a(2);
                          }
                        }, _callee7);
                      }));
                      return function (_x8) {
                        return _ref8.apply(this, arguments);
                      };
                    }();
                  });
                case 1:
                  return _context8.a(2);
              }
            }, _callee8);
          }));
          return function (_x7) {
            return _ref7.apply(this, arguments);
          };
        }();
      }
    }
  }]);
}();
module.exports = ChatUserMenu;